import { createStyles, makeStyles } from '@material-ui/styles';

const style = () =>
  createStyles({
    root: {
      display: 'flex',
      gap: '10px',
      flexWrap: 'wrap'
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
